module.exports = __webpack_public_path__ + "static/media/lang13.8dc0be66.mp3";